import { render, staticRenderFns } from "./PayFeedback.vue?vue&type=template&id=2fb38991"
import script from "./PayFeedback.vue?vue&type=script&lang=js"
export * from "./PayFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports